import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Cake, X } from "lucide-react";
import { fmtDate } from "@/lib/format";

const ROLE_LABELS = {
  admin: "Süper Admin", sales: "Satış Personeli",
  accounting: "Muhasebe", warehouse: "Depo", viewer: "Görüntüleme",
};

const dismissKey = () => `azd_bd_dismiss_${new Date().toISOString().slice(0, 10)}`;

export default function BirthdayBanner() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!user) return;
    if (!["admin", "accounting"].includes(user.role)) return;
    // Auto-dismiss per day
    if (sessionStorage.getItem(dismissKey())) {
      setHidden(true);
    }
    api.get("/dashboard/upcoming-birthdays", { params: { days: 14 } })
      .then((r) => setItems(r.data))
      .catch(() => setItems([]));
  }, [user]);

  if (!user || !["admin", "accounting"].includes(user.role)) return null;
  if (hidden || items.length === 0) return null;

  const close = () => {
    sessionStorage.setItem(dismissKey(), "1");
    setHidden(true);
  };

  return (
    <div
      data-testid="birthday-banner"
      className="mb-4 rounded-xl border border-[#FFE600]/60 bg-gradient-to-r from-[#FFFBEA] to-[#FFF7CC] p-4 flex items-start gap-3 shadow-sm"
    >
      <div className="w-10 h-10 rounded-lg bg-[#0B3676] text-[#FFE600] flex items-center justify-center shrink-0">
        <Cake size={20} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-extrabold text-[#08285A] text-sm">
          Yaklaşan Doğum Günleri
          <span className="ml-2 text-xs font-semibold text-[#6B7280]">
            (önümüzdeki 14 gün)
          </span>
        </div>
        <div className="mt-2 flex flex-wrap gap-2">
          {items.map((p) => {
            const dayLabel = p.is_today
              ? "BUGÜN 🎉"
              : p.days_left === 1
              ? "yarın"
              : `${p.days_left} gün sonra`;
            return (
              <div
                key={p.user_id}
                data-testid={`bd-${p.user_id}`}
                className={`px-3 py-2 rounded-lg border text-xs ${
                  p.is_today
                    ? "bg-[#0B3676] text-white border-[#0B3676]"
                    : "bg-white border-[#E5E7EB] text-[#111827]"
                }`}
              >
                <div className="font-bold">{p.full_name}</div>
                <div className={p.is_today ? "text-[#FFE600]" : "text-[#6B7280]"}>
                  {ROLE_LABELS[p.role] || p.role} • {fmtDate(p.next_birthday)} ({dayLabel})
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <button
        onClick={close}
        data-testid="close-birthday-banner"
        className="p-1 rounded hover:bg-black/5 text-[#6B7280]"
        title="Kapat"
      >
        <X size={16} />
      </button>
    </div>
  );
}
